import { render, staticRenderFns } from "./HeaderColapseInvoices.vue?vue&type=template&id=71431927&scoped=true"
import script from "./HeaderColapseInvoices.vue?vue&type=script&lang=js"
export * from "./HeaderColapseInvoices.vue?vue&type=script&lang=js"
import style0 from "./HeaderColapseInvoices.vue?vue&type=style&index=0&id=71431927&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71431927",
  null
  
)

export default component.exports